import { useEffect } from 'react';

const SEO = ({ title, description, keywords, canonical, ogImage }) => {
  useEffect(() => {
    // Update document title
    if (title) {
      document.title = `${title} | CineRecs`;
    }

    // Update meta description
    const updateMetaTag = (name, content) => {
      let element = document.querySelector(`meta[name="${name}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute('name', name);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    // Update or create description
    if (description) {
      updateMetaTag('description', description);
    }

    // Update or create keywords
    if (keywords) {
      updateMetaTag('keywords', keywords);
    }

    // Update Open Graph tags for social sharing
    if (title) {
      updateMetaTag('og:title', title);
    }
    if (description) {
      updateMetaTag('og:description', description);
    }
    if (ogImage) {
      updateMetaTag('og:image', ogImage);
    }

    // Update canonical URL
    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', canonical);
    }

    // Cleanup function
    return () => {
      // Reset to defaults if needed
      document.title = 'CineRecs | Cinema Recommendations';
    };
  }, [title, description, keywords, canonical, ogImage]);

  return null; // This component doesn't render anything
};

export default SEO;
